export const BRAND = {
  name: "Tinkr",
  legalName: "Tinkr App Ltd",
  companyNumber: "17142710",
  registeredJurisdiction: "England and Wales",
  registeredOffice: "71-75 Shelton Street, Covent Garden, London WC2H 9JQ, UK",
  supportEmail: "support@tinkrapp.com",
  colors: {
    // Primary brand orange. Use for display elements only: large headings
    // (>=18.66px bold or >=24px regular), brand marks, icons, and large CTA
    // button backgrounds where the text-on-button contrast is handled
    // separately. This color is intentionally vivid and does NOT meet WCAG
    // AA (4.5:1) for small text against the `cream` background — use
    // `primaryAccessible` for body-text-size usages on light surfaces.
    primary: "#F07942",
    // AA-compliant orange for body-text-size usages on light/cream
    // backgrounds. Contrast ratios (WCAG 2.1 relative luminance):
    //   #A23F09 vs #F7FBF7 (cream) = 6.18:1  (passes AA, AAA for normal text)
    //   #A23F09 vs #FFFFFF (white) = 6.46:1  (passes AA, AAA for normal text)
    // Hue is preserved from the brand orange family; the value differs
    // only in lightness so it reads as the same brand color, just darker.
    // Mirrors the `--brand-strong: #a23f09` light-theme override in
    // styles.css so any inline-style component matches the stylesheet.
    primaryAccessible: "#A23F09",
    // Darker brand-orange shade for :hover / :active states on the
    // primary CTA. Same hue, ~10% darker. Stays opaque (no rgba) so it
    // works against any surface.
    primaryHover: "#D6622D",
    cream: "#F7FBF7",
    dark: "#07110F",
    deep: "#006B5C",
    mid: "#0F8F7D",
    // Secondary / tertiary text on light surfaces. Mirror the
    // `--muted-strong` and `--muted` light-theme values in styles.css so
    // standalone surfaces that can't read CSS custom properties (notably
    // TeaserSplash, which mounts without the dashboard app shell) still
    // get the same on-cream typography hierarchy.
    textSecondary: "#34433E",
    textTertiary: "#65736E",
    // Dark fallback for image placeholders / opaque dark surfaces on the
    // teaser. Mirrors `--surface` dark-theme.
    surfaceDark: "#0D1715"
  },
  logos: {
    // `tinkr-logo/` ships the correctly-composed lockup: the T-mark (4 stacked
    // chevrons + crossbar rect) followed by an `inkr` wordmark rendered as
    // outlined paths — together the visible glyphs read "Tinkr" with the mark
    // serving as the leading T. The `logos-svg/` set ships a broken design
    // (chevron-T + a separate "Tinkr" text element, producing a double-T
    // when rendered) and must not be used until the brand pack is corrected.
    // Wordmark-as-paths means the SVG renders identically when embedded via
    // `<img>` — no page-font dependency.
    fullColorHorizontal: "/brand/tinkr-logo/text-logo-color.svg",
    emailHorizontal: "/brand/email/tinkr-logo.png",
    fullColorMark: "/brand/tinkr-logo/logo-color.svg"
  }
} as const;
